import { render, staticRenderFns } from "./depname.vue?vue&type=template&id=751203d1"
import script from "./depname.vue?vue&type=script&lang=js"
export * from "./depname.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports